import React from 'react'

import { ReactComponent as ChevronLeftSvg } from '../../../../assets/svgs/chevron-left.svg'

type ChevronLeftProps = {
  className?: string
  size?: string | number
}

export const ChevronLeft = ({
  className = '',
  size = 24,
}: ChevronLeftProps) => (
  <ChevronLeftSvg width={size} height={size} className={className} />
)
